import { useUsersLayout } from 'app/components/users-layout/useUsersLayout'
import { UsersLayoutShadcnComponent } from 'app/components/users-layout/UsersLayoutShadcnComponent'

export default function Users(): React.ReactElement {
  const { children } = useUsersLayout()
  return <UsersLayoutShadcnComponent>{children}</UsersLayoutShadcnComponent>
}
